import { initializeApp } from "firebase/app";
import {
  getAuth,
  // GoogleAuthProvider
} from "firebase/auth";
import { getFirestore, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

import { deployment } from "./envConfig";

const firebaseConfigWeb =
  deployment === "production"
    ? {
      apiKey: "AIzaSyDowG3s9pyvi8UxI3LiJghRQ1KrckXEdFI",
      authDomain: "practido-ai-assessment.firebaseapp.com",
      projectId: "practido-ai-assessment",
      storageBucket: "practido-ai-assessment.appspot.com",
      messagingSenderId: "620694934859",
      appId: "1:620694934859:web:79d2b7808d229f459c84ce",
      measurementId: "G-MEYY6ZYBCX",
    }
    : {
      apiKey: "AIzaSyDvL_xP6uAiBKhsWen7WApQC1qVdkGC4ow",
      authDomain: "naskay-test.firebaseapp.com",
      projectId: "naskay-test",
      storageBucket: "naskay-test.appspot.com",
      messagingSenderId: "221453283973",
      appId: "1:221453283973:web:0aa2efde3065e1dc89afec",
      measurementId: "G-H98EEM5XTJ",
    };

const firebaseConfigMobile =
  deployment === "production"
    ? {
      apiKey: "AIzaSyBTgFpEv9t-Zo0KwIsZJadXRs58m0w94RY",
      authDomain: "olympiad-practice.firebaseapp.com",
      projectId: "olympiad-practice",
      storageBucket: "olympiad-practice.appspot.com",
      messagingSenderId: "974880430325",
      appId: "1:974880430325:web:fcee6dfa753d9d5b100dbc",
      measurementId: "G-WY3Z19Y85E"
    }
    : {
      apiKey: "AIzaSyBnpxyZM2bnh4JkKFtEcDl6XA_qkiXwKQg",
      authDomain: "mathquizandroid.firebaseapp.com",
      databaseURL: "https://mathquizandroid-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "mathquizandroid",
      storageBucket: "mathquizandroid.appspot.com",
      messagingSenderId: "407001171228",
      appId: "1:407001171228:web:05b5db747081e3325c26d9",
      measurementId: "G-YGFF9HJ44M"
    }

export const app = initializeApp(firebaseConfigWeb);
export const appMobile = initializeApp(firebaseConfigMobile, "mobileApp");

export const auth = getAuth(app);
export const authMobile = getAuth(appMobile);

export const db = getFirestore(app);
export const dbMobile = getFirestore(appMobile);

export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export const schoolCollectionRef = collection(db, "schools");
export const parentsCollectionRef = collection(db, "parents");
export const participantsCollectionRef = collection(db, "participants");
export const paymentCollectionRef = collection(db, "payments");
export const questionsCollectionRef = collection(db, "questions");
